import React from 'react'

import './MealDivisionEditor.css'
import MealPreferencesControl, {
  MealPreferencesControlOnChangeFn,
} from '../MealPreferencesControl/MealPreferencesControl'
import { getSelectedMealsFromMealDivisions } from '@/utils'
import { MealOfDayDivision } from '@/api/types'
import { GenerateMealDivisionIdFn } from '../MealPreferencesControl/SelectedMealDivisions'

type MealDivisionEditorProps = {
  mealDivisions: Array<MealOfDayDivision>
  generateMealDivisionId: GenerateMealDivisionIdFn
  onChange: MealPreferencesControlOnChangeFn
}

export function MealDivisionEditor({
  mealDivisions,
  generateMealDivisionId,
  onChange,
}: MealDivisionEditorProps) {
  const selectedMeals = getSelectedMealsFromMealDivisions(mealDivisions)

  return (
    <div className="mealDivisionEditor">
      <h3>Meal divisions</h3>
      <div className="mealsDivisionEditor">
        <MealPreferencesControl
          selectedMeals={selectedMeals}
          mealOfDayDivisions={mealDivisions}
          // requiredMeals={[]}
          onChange={onChange}
          generateMealDivisionId={generateMealDivisionId}
        />
      </div>
    </div>
  )
}
